import { render, staticRenderFns } from "./audioMp3.vue?vue&type=template&id=52c019e2&scoped=true"
import script from "./audioMp3.vue?vue&type=script&lang=js"
export * from "./audioMp3.vue?vue&type=script&lang=js"
import style0 from "./audioMp3.vue?vue&type=style&index=0&id=52c019e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c019e2",
  null
  
)

export default component.exports